<!--<button mat-mini-fab class="add-btn" (click)="increaseValue()">-->
<!--  <mat-icon>add</mat-icon>-->
<!--</button>-->
<!--<input type="number" [(ngModel)]="modelValue">-->
<!--<button mat-mini-fab color="accent" class="remove-btn" (click)="decreaseValue()">-->
<!--  <mat-icon>remove</mat-icon>-->
<!--</button>-->
  <span class="minus" (click)="decreaseValue()"><i class="icon-minus"></i></span>
  <input type="number" [(ngModel)]="modelValue">
  <span class="plus" (click)="increaseValue()"><i class="icon-plus"></i></span>
